module.exports = __webpack_public_path__ + "static/media/lagodigital_16.211150cf.jpg";